import { render, staticRenderFns } from "./UploadRecordModal.vue?vue&type=template&id=16a1a39f&"
import script from "./UploadRecordModal.vue?vue&type=script&lang=js&"
export * from "./UploadRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports